import styled, { css } from "styled-components";
import { border, color, layout, typography } from "styled-system";
import { includeStyledSystem } from "../../util/styledSystem";
export const getTextAreaVariants = ({ colors: { inputColors }, shadows }) => ({
    error: {
        "&:disabled": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        "&:focus": {
            borderColor: inputColors.inputFocusBorder,
            boxShadow: shadows.searchBox.contentShadow,
        },
        "&:read-only": {
            backgroundColor: inputColors.inputDisabledBackground,
            borderColor: inputColors.inputDisabledBorder,
            color: inputColors.inputDisabledText,
        },
        backgroundColor: inputColors.inputBackground,
        borderColor: inputColors.inputErrorBorder,
    },
});
export const TextArea = styled.textarea `
  ${border}
  ${color}
  ${layout}
  ${typography}
  ${({ theme: { colors: { inputColors }, fontSizes, fonts: { main }, shadows: { searchBox: { contentShadow }, }, }, resize, }) => css `
    resize: ${resize || "both"};
    border-radius: 5px;
    border: solid 1px ${inputColors.inputBorder};
    color: ${inputColors.inputText};

    :focus {
      border-color: ${inputColors.inputFocusBorder};
      box-shadow: ${contentShadow};
    }

    :disabled,
    :read-only {
      border-color: ${inputColors.inputDisabledBorder};
      background-color: ${inputColors.inputDisabledBackground};
      color: ${inputColors.inputDisabledText};
    }

    ::placeholder {
      color: ${inputColors.inputPlaceholder};
    }

    background: ${inputColors.inputBackground};
    font-size: ${fontSizes[1]}px;
    font-family: ${main};
  `}
  ${includeStyledSystem() /* Allows to use attributes to set styles */}
  padding: 12px;
  ${({ theme, variant }) => (Object.assign({}, (variant ? getTextAreaVariants(theme)[variant] : {})))}
`; // Cast the type explicitly for Storybook Controls
